export class ValidationError extends Error {
    constructor(errors) {
        super(JSON.stringify(errors));
        this.name = 'ValidationError';
        this.errors = errors;
    }
}
export class NonJSONResponseError extends Error {
    constructor(contentType, response) {
        super(`Endpoint returned ${contentType} instead of json`);
        this.name = 'NonJSONResponseError';
        this.contentType = contentType;
        this.response = response;
    }
}
//# sourceMappingURL=errors.js.map